import { render, staticRenderFns } from "./AscUserComment.vue?vue&type=template&id=d8e9283e&"
import script from "./AscUserComment.vue?vue&type=script&lang=js&"
export * from "./AscUserComment.vue?vue&type=script&lang=js&"
import style0 from "./AscUserComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports